/**
 * /app/trusts/$id/people — People & access (route shell).
 *
 * Screen impl in `./people-screen.tsx`, lazy-loaded via `lazyRouteComponent`.
 * The main new UI surface of the Multi-member End-Client Access feature (B6):
 * the trust's deed roster joined to portal-access status + tier, with trustee-
 * tier controls to change a member's tier, revoke access, or invite a new
 * member. A deep trust sub-tab, not a first-paint route, so the body leaves the
 * entry bundle (200 kB gzip budget) — same shell+screen pattern as the sibling
 * `./settings.tsx` / `./beneficiaries/index.tsx` tabs. The committed
 * routeTree.gen.ts imports only `Route` from here, so no plugin regen is needed.
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/app/trusts/$id/people/')({
  component: lazyRouteComponent(() => import('./people-screen'), 'PeopleScreen'),
});
